import CompanyVehicles from './CompanyVehicles';

export default CompanyVehicles;
